import { CourseCatalogPostingStream } from 'app/library/course-catalog-landing-page/models/course-catalog-posting-stream.model';
import { CourseCatalogCategoryType } from '../enums/course-catalog-category-type.enum';
import { ICourseCatalogOverviewCategoryQuery } from '../interfaces/course-catalog-overview-category.query.interface';

// @dynamic
export class CourseCatalogOverviewCategory {
    id: string;
    name: string;
    hasPublishedSubCategories: boolean;
    type: CourseCatalogCategoryType;

    isSelected?: boolean;
    open?: boolean;
    children?: CourseCatalogOverviewCategory[];
    postingStream?: CourseCatalogPostingStream[];

    constructor(query?: ICourseCatalogOverviewCategoryQuery) {
        if (query) {
            this.id = query.id.toString();
            this.name = query.name;
            this.hasPublishedSubCategories = query.has_published_sub_categories;
            this.type = query.type;
        }
    }
}
